<template>
  <b-container fluid>
    <lca-detail-header lca="다운스트림 운송"
                       :total="total"
                       :total-per-production="totalPerProduction"
                       :rank="rank"/>

    <downstream-detail :product="product"
                       :year="year"
                       class="mt-3"
                       @totalCalculated="onTotalCalculated"/>

    <b-row class="mt-5">
      <b-col lg="6">
        <b class="content-title mb-3">협력사별 온실가스 배출비율</b>
        <product-downstream-emission-by-partner :product="product"
                                                :year="year"/>
      </b-col>
      <b-col lg="6"
             class="mt-5 mt-lg-0">
        <b class="content-title mb-3">협력사 온실가스 배출량 상세</b>
        <downstream-partner-detail type="downstream"
                                   :product="product"
                                   :year="year"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DownstreamDetail from "../tables/DownstreamDetail.vue";
import ProductDownstreamEmissionByPartner from "../charts2/ProductDownstreamEmissionByPartner.vue";
import DownstreamPartnerDetail from "../tables/TransportationPartnerDetail.vue";
import LcaDetailHeader from "@/components/esg/3. Monitoring/3.2. LCA 배출량 관리/3.2.1. 제품별/LcaDetailHeader.vue";

export default {
  // 다운스트림 운송 상세
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  components: {
    LcaDetailHeader,
    ProductDownstreamEmissionByPartner,
    DownstreamDetail,
    DownstreamPartnerDetail,
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchRanks()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchRanks()
      }
    }
  },
  computed: {
    lca() {
      return this.$store.getters['ghg/lifeCycleStages'];
    },
    formattedRank() {
      if (!this.rank || !this.rank.rank || !this.rank.count) return null
      return `(${this.rank.rank}/${this.rank.count})`
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchRanks() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return;
      if (!this.year) return;

      try {
        this.loading = true;

        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          categories: [this.lca[3].value]
        }];

        let data = new FormData()
        data.append('path', 'esg/lca/rank/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: {Authorization: accessToken()},
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          this.rank = {rank: null, count: null}
          return
        }

        // Parse JSON data
        this.rank = JSON.parse(response.data.data)[0].data[0];
      } catch (error) {
        await this.showError(error)
      }
    },
    onTotalCalculated(total, totalPerProduction) {
      this.total = total;
      this.totalPerProduction = totalPerProduction
    }
  },
  data() {
    return {
      total: 0,
      totalPerProduction: 0,
      rank: {rank: 0, count: 0},
    }
  },
}
</script>
